import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableStateDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center"
    },
    icon: {
        justifyContent: "center",
        alignItems: "center"
    },
    content: {
        alignItems: "center",
        alignSelf: "center"
    },
    text: {
        textAlign: "center"
    }
});

export const useStyles = ({
    controlHeights,
    shapeConfigs,
    radiuses,
    spaces,
    colors
}: DataTableStateDynamicStyleType) => {
    const styles = {
        icon: {
            backgroundColor: colors.content.container.subtle,
            marginBottom: spaces.spacingSm,
            height: controlHeights.large,
            borderRadius: radiuses.full,
            width: controlHeights.large
        } as Mutable<ViewStyle>,
        content: {
            maxWidth: shapeConfigs.dialogMaxWidth,
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        container: {
            paddingHorizontal: spaces.spacingMd,
            minHeight: controlHeights.large * 4,
            paddingVertical: spaces.spacingXl
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
